"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.getStorageShouldBeAvailable = exports.setStorageShouldBeAvailable = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _DeviceInfoHelper = _interopRequireDefault(require("../helpers/DeviceInfoHelper"));

var _ArrayHelper = require("../helpers/ArrayHelper");

var STORAGE_SHOULD_BE_AVAILABLE = false;
var waitingCallbacks = [];

var setStorageShouldBeAvailable = function setStorageShouldBeAvailable(available) {
  STORAGE_SHOULD_BE_AVAILABLE = available;

  if (available) {
    waitingCallbacks.forEach(function (callback) {
      callback();
    });
  }
};

exports.setStorageShouldBeAvailable = setStorageShouldBeAvailable;

var getStorageShouldBeAvailable = function getStorageShouldBeAvailable() {
  return STORAGE_SHOULD_BE_AVAILABLE;
};

exports.getStorageShouldBeAvailable = getStorageShouldBeAvailable;

var waitForStorage = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!STORAGE_SHOULD_BE_AVAILABLE) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
              waitingCallbacks.push(function () {
                resolve();
              });
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function waitForStorage() {
    return _ref.apply(this, arguments);
  };
}();

var writeOrder = [];
/** @namespace window.chrome */

var AppNativeStorage = /*#__PURE__*/function () {
  function AppNativeStorage() {
    (0, _classCallCheck2["default"])(this, AppNativeStorage);
  }

  (0, _createClass2["default"])(AppNativeStorage, null, [{
    key: "clearAll",
    value: function () {
      var _clearAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(key) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return waitForStorage();

              case 2:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context2.next = 5;
                  break;
                }

                window.localStorage.clear();
                return _context2.abrupt("return", _promise["default"].resolve());

              case 5:
                return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                  window.chrome.storage.local.clear(resolve, reject);
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function clearAll(_x) {
        return _clearAll.apply(this, arguments);
      }

      return clearAll;
    }()
  }, {
    key: "getValue",
    value: function () {
      var _getValue = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(key) {
        var obj;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return waitForStorage();

              case 2:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context3.next = 12;
                  break;
                }

                obj = window.localStorage.getItem(key);
                _context3.prev = 4;
                return _context3.abrupt("return", _promise["default"].resolve(JSON.parse(obj)));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](4);
                console.error("error getting native value for key ".concat(key, " ->"), _context3.t0);
                return _context3.abrupt("return", _promise["default"].reject(_context3.t0));

              case 12:
                return _context3.abrupt("return", new _promise["default"](function (resolve, reject) {
                  // console.log(`getting native value for key ${key}`)
                  window.chrome.storage.local.get(key, function (obj) {
                    try {
                      // console.log(`getting native value for key ${key} -> `, obj)
                      if (obj && obj[key]) {
                        try {
                          var json = JSON.parse(obj[key]);
                          resolve(json);
                        } catch (error) {// ignore
                        }
                      }

                      resolve(null);
                    } catch (error) {
                      console.error("error getting native value for key ".concat(key, " ->"), error);
                      reject(error);
                    }
                  }, reject);
                }));

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 8]]);
      }));

      function getValue(_x2) {
        return _getValue.apply(this, arguments);
      }

      return getValue;
    }()
  }, {
    key: "removeValue",
    value: function () {
      var _removeValue = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(key) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return waitForStorage();

              case 2:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context4.next = 5;
                  break;
                }

                window.localStorage.removeItem(key);
                return _context4.abrupt("return", _promise["default"].resolve());

              case 5:
                return _context4.abrupt("return", new _promise["default"](function (resolve, reject) {
                  window.chrome.storage.local.remove(key, resolve, reject);
                }));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function removeValue(_x3) {
        return _removeValue.apply(this, arguments);
      }

      return removeValue;
    }()
  }, {
    key: "saveValue",
    value: function () {
      var _saveValue = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(key, value) {
        var releaseFn;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return waitForStorage();

              case 2:
                _context5.next = 4;
                return (0, _ArrayHelper.waitForTurn)(writeOrder);

              case 4:
                releaseFn = _context5.sent;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context5.next = 9;
                  break;
                }

                window.localStorage.setItem(key, (0, _stringify["default"])(value));
                releaseFn();
                return _context5.abrupt("return", _promise["default"].resolve());

              case 9:
                return _context5.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var obj = {};
                  obj[key] = (0, _stringify["default"])(value);

                  try {
                    window.chrome.storage.local.set(obj, resolve, reject);
                    releaseFn();
                  } catch (error) {
                    console.error(error);
                    releaseFn();
                    reject(error);
                  }
                }));

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function saveValue(_x4, _x5) {
        return _saveValue.apply(this, arguments);
      }

      return saveValue;
    }()
  }]);
  return AppNativeStorage;
}();

AppNativeStorage.KEYS = {
  ASPECTS: 'aspects',
  CURRENT_ASPECT: 'currentAspects',
  DATA: 'data',
  LOGS: 'logs',
  RELEVANCES: 'relevances'
};
var _default = AppNativeStorage;
exports["default"] = _default;